import React, { useEffect, useRef, useState } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import '../../styles/quill-custom.css';


export default function BusinessDescriptionModal({ opened, onClose, initialContent, onSave }) {
  console.log('[Modal] Received initialContent prop:', initialContent);
  const editorRef = useRef(null);
  const quillInstance = useRef(null);
  const [content, setContent] = useState('');
  const [instanceId, setInstanceId] = useState(0);

  useEffect(() => {
    if (!opened) {
      setInstanceId(prev => prev + 1);
    }
  }, [opened]);

useEffect(() => {
  if (opened && editorRef.current) {
    console.log('[Modal] opened:', opened);
    console.log('[Modal] incoming initialContent:', initialContent);

    // ✅ Full cleanup of prior instance and toolbar
    if (quillInstance.current) {
      const quill = quillInstance.current;

      // 🧼 Remove toolbar element explicitly
      const toolbar = quill.container?.previousSibling;
      if (toolbar?.classList?.contains('ql-toolbar')) {
        toolbar.remove();
      }

      quill.container.innerHTML = '';
      quillInstance.current = null;
    }

    console.log('[Quill] Creating new instance.');
    quillInstance.current = new Quill(editorRef.current, {
      theme: 'snow',
      placeholder: 'Describe your business here...',
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ color: [] }, { background: [] }],
          [{ script: 'sub' }, { script: 'super' }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ align: [] }],
          ['link', 'blockquote', 'clean'] // ❌ code-block removed
        ],
      },
    });
    const toolbar = document.querySelector('.ql-toolbar');
    if (toolbar) {
      toolbar.querySelector('.ql-header[value="1"]')?.setAttribute('title', 'Heading 1');
      toolbar.querySelector('.ql-header[value="2"]')?.setAttribute('title', 'Heading 2');
      toolbar.querySelector('.ql-header[value="3"]')?.setAttribute('title', 'Heading 3');
      toolbar.querySelector('.ql-header[value="false"]')?.setAttribute('title', 'Normal Text');
      toolbar.querySelector('.ql-bold')?.setAttribute('title', 'Bold');
      toolbar.querySelector('.ql-italic')?.setAttribute('title', 'Italic');
      toolbar.querySelector('.ql-underline')?.setAttribute('title', 'Underline');
      toolbar.querySelector('.ql-strike')?.setAttribute('title', 'Strikethrough');
      toolbar.querySelector('.ql-color')?.setAttribute('title', 'Text Color');
      toolbar.querySelector('.ql-background')?.setAttribute('title', 'Background Color');
      toolbar.querySelector('.ql-script[value="sub"]')?.setAttribute('title', 'Subscript');
      toolbar.querySelector('.ql-script[value="super"]')?.setAttribute('title', 'Superscript');
      toolbar.querySelector('.ql-list[value="ordered"]')?.setAttribute('title', 'Ordered List');
      toolbar.querySelector('.ql-list[value="bullet"]')?.setAttribute('title', 'Bullet List');
      toolbar.querySelector('.ql-align')?.setAttribute('title', 'Text Alignment');
      toolbar.querySelector('.ql-link')?.setAttribute('title', 'Insert Link');
      toolbar.querySelector('.ql-blockquote')?.setAttribute('title', 'Blockquote');
      toolbar.querySelector('.ql-clean')?.setAttribute('title', 'Clear Formatting');
    }

    const contentToSet = initialContent || '';
    quillInstance.current.root.innerHTML = contentToSet;
    setContent(contentToSet);

    const handler = () => {
      setContent(quillInstance.current.root.innerHTML);
    };
    quillInstance.current.on('text-change', handler);

    // ✅ Cleanup on modal close
    return () => {
      if (quillInstance.current) {
        quillInstance.current.off('text-change', handler);

        const quill = quillInstance.current;
        const toolbar = quill.container?.previousSibling;
        if (toolbar?.classList?.contains('ql-toolbar')) {
          toolbar.remove();
        }

        quill.container.innerHTML = '';
        quillInstance.current = null;
        if (editorRef.current) editorRef.current.innerHTML = '';
      }
    };
  }
}, [opened, initialContent]);




  const handleSave = () => {
    if (quillInstance.current) {
      const updatedHTML = quillInstance.current.root.innerHTML;
      onSave(updatedHTML);
    }
  };

  if (!opened) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-[1001]"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-lg p-6 w-full max-w-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-semibold mb-4">Edit Your Business Description</h2>
        <div ref={editorRef} style={{ height: '300px' }} />

        <div className="flex justify-end mt-4 gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded bg-gray-200 text-gray-800 hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
